export { default } from '../de/Imprint';



// WEBPACK FOOTER //
// ./src/components/async/deImprint.js